import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintApiManager_ds_find_lotsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { searchProperties: { lotId?: number, lotCode?: string, materialId?: number, vendorLotId?: number }[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number, VendorLotId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.searchProperties)) {
      missingRequiredInParams.push('\'searchProperties\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_find_lots/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { searchProperties: { lotId?: number, lotCode?: string, materialId?: number, vendorLotId?: number }[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number, VendorLotId?: number }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.searchProperties)) {
      missingRequiredInParams.push('\'searchProperties\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_find_lots/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { searchProperties: { lotId?: number, lotCode?: string, materialId?: number, vendorLotId?: number }[], $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, MaterialId?: number, VendorLotId?: number }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.searchProperties)) {
      missingRequiredInParams.push('\'searchProperties\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintApiManager/datasources/ds_find_lots/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

